// Feature flags centralizzati. Punto unico di verità per accendere/spegnere
// funzionalità dell'app senza toccare il codebase né rimuovere componenti.
//
// BARCODE_ENABLED: la scansione barcode via camera (e il relativo campo
// manuale nel form prodotto) è nascosta in tutta la UI finché il flag è false.
// Il componente e il campo dato lato backend restano intatti per un'eventuale
// riattivazione futura senza migrazioni.
export const BARCODE_ENABLED = false;
